export const getSchedule = (schedule: string[] | undefined) => {
  return schedule?.map((item: string) => {
    let separator = item.indexOf(":");
    let day = item.substring(0, separator);
    let working_hours = item.substring(separator + 1, item.length);
    return { day, working_hours };
  });
};
